import { Box, Link, Popover, Tooltip, Typography } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import "./WebLinkCell.scss";

const boxSx = {
  px: 1.5,
  py: 1,
  maxWidth: 280,
  whiteSpace: "normal",
  overflowWrap: "break-word",
  wordBreak: "break-word",
  borderRadius: 2,
  backgroundColor: "background.paper",
  color: "text.primary",
  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
};

export default function ProjectsCell({ params }) {
  const projects = params?.row?.partnerProjects || [];
  const [anchorEl, setAnchorEl] = useState(null);

  if (!projects.length) {
    return <Typography variant="body2">N/A</Typography>;
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const projectNames = projects.map(project => project.projectName).filter(Boolean).join(", ");

  return (
    <>
      <Tooltip
        title="Click to see the projects."
        placement="bottom"
        arrow
        slotProps={{
          tooltip: { sx: { ...boxSx, fontSize: "0.8125rem", fontWeight: 400 } },
          arrow: { sx: { color: "background.paper" } }
        }}
      >
        <Link
          className="proGrid-link"
          component="button"
          type="button"
          underline="none"
          color="primary"
          aria-label={`${projects.length} projects`}
          aria-haspopup="dialog"
          aria-expanded={Boolean(anchorEl) ? "true" : undefined}
          onClick={handleClick}
          sx={{ display: "inline-flex", alignItems: "center", gap: "2px" }}
        >
          {projects.length}
          <ExpandMore fontSize="small" />
        </Link>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        slotProps={{ paper: { sx: { mt: 0.5, ...boxSx } } }}
      >
        <Box>
          <Typography variant="body2" sx={{ whiteSpace: "normal", overflowWrap: "break-word" }}>
            {projectNames}
          </Typography>
        </Box>
      </Popover>
    </>
  );
}

ProjectsCell.propTypes = {
  params: PropTypes.object.isRequired
};
